import type { GetIndicatorByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetIndicatorByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIndicatorByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetIndicatorByIdArgs = {
  id: string;
};

export const useGetIndicatorById = createQueryHook<
  UseGetIndicatorByIdArgs,
  GetIndicatorByIdResponseRow[],
  GetIndicatorByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.indicator.indicatorById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ indicator: data ?? [] }),
  graphqlDocument: GetIndicatorByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
  // The indicator detail (title, etc.) is shared by every tab on the update
  // page. Without a stale time the query defaults to staleTime 0 and refetches
  // whenever a tab re-subscribes, making the object toolbar reload its title on
  // each tab switch. Keep it fresh for 5 minutes so tab switches serve from
  // cache; mutations still invalidate it explicitly (CUS-150).
  trpcStaleTime: 5 * 60 * 1000,
});
